export default {
  //ROLES
  ADMIN: "ADMIN",
  COMITE: "COMITE",
  DIRESF: "DIRESF",
  MERCHANT: "MERCHANT",
  MERCHANT_GROUP: "MERCHANT_GROUP",
  get ALL_ROLES() {
    return [
      this.ADMIN,
      this.COMITE,
      this.DIRESF,
      this.MERCHANT,
      this.MERCHANT_GROUP
    ];
  },
  get ALL_ROLES_WITHOUT_ESF() {
    return [this.ADMIN, this.COMITE, this.MERCHANT, this.MERCHANT_GROUP];
  },

  //PRIVILEGES
  BAREBONE_NAVIGATION: "BAREBONE_NAVIGATION",
  FULL_NAV: "FULL_NAV",
  REDUCED_NAV_MERCHANT_GROUP: "REDUCED_NAV_MERCHANT_GROUP",
  REDUCED_NAV: "REDUCED_NAV",

  CREATE_MERCHANT: "CREATE_MERCHANT",
  UPDATE_FOR_ESF: "UPDATE_FOR_ESF",
  UPDATE_FOR_MERCHANT: "UPDATE_FOR_MERCHANT",

  MERCHANT_EDIT_NAME_FIELD: "MERCHANT_EDIT_NAME_FIELD",
  MERCHANT_EDIT_KIND_FIELD: "MERCHANT_EDIT_KIND_FIELD",
  MERCHANT_EDIT_CODE_FIELD: "MERCHANT_EDIT_CODE_FIELD",
  MERCHANT_EDIT_MAIN_RESORT_FIELD: "MERCHANT_EDIT_MAIN_RESORT_FIELD",
  MERCHANT_EDIT_APPACCOUNTID_FIELD: "MERCHANT_EDIT_APPACCOUNTID_FIELD",
  MERCHANT_EDIT_APPUSERID_FIELD: "MERCHANT_EDIT_APPUSERID_FIELD",
  MERCHANT_EDIT_EMAIL_FIELD: "MERCHANT_EDIT_EMAIL_FIELD",
  MERCHANT_EDIT_NOTES_FIELD: "MERCHANT_EDIT_NOTES_FIELD",
  MERCHANT_EDIT_MERCHANT_GROUP_FIELD: "MERCHANT_EDIT_MERCHANT_GROUP_FIELD",
  MERCHANT_EDIT_FACET_FIELD: "MERCHANT_EDIT_FACET_FIELD",
  // MERCHANT_EDIT_COPY_FIELD: 'MERCHANT_EDIT_COPY_FIELD',
  // MERCHANT_EDIT_EMAIL_COMMENT_FIELD: 'MERCHANT_EDIT_EMAIL_COMMENT_FIELD',

  FULL_MERCHANT_ROUTES: "FULL_MERCHANT_ROUTES",
  PARAMETER_MERCHANT_ROUTE: "PARAMETER_MERCHANT_ROUTE",
  FULL_TABS_DISPLAY: "FULL_TABS_DISPLAY",
  PARAMETER_TAB_DISPLAY: "PARAMETER_TAB_DISPLAY",
  IMPORT_MERCHANT_CSV_ROUTE: "IMPORT_MERCHANT_CSV_ROUTE",
  IMPORT_MERCHANT_CSV_TAB_DISPLAY: "IMPORT_MERCHANT_CSV_TAB_DISPLAY",

  DISPLAY_SPECIFIC_PARAMETERS: "DISPLAY_SPECIFIC_PARAMETERS",
  DISPLAY_E_TICKET: "DISPLAY_E_TICKET",

  DISPLAY_MERCHANT_HEADER: "DISPLAY_MERCHANT_HEADER",
  LISTS_REQUESTS_EXTENDED_PARAMETERS: "LISTS_REQUESTS_EXTENDED_PARAMETERS",
  LISTS_REQUESTS_KIND_PARAMETERS: "LISTS_REQUESTS_KIND_PARAMETERS",

  SALES_LISTS_LOAD_FILTERS: "SALES_LISTS_LOAD_FILTERS",
  ORDER_RE_EXPORT: "ORDER_RE_EXPORT",

  SALES_LIST_RENDER_RESORT: "SALES_LIST_RENDER_RESORT",
  SALES_LIST_RENDER_KIND: "SALES_LIST_RENDER_KIND",
  SALES_LIST_RENDER_MERCHANTS: "SALES_LIST_RENDER_MERCHANTS",
  SALES_LIST_RENDER_SPACERS: "SALES_LIST_RENDER_SPACERS",
  SALES_LIST_RENDER_KIND_SPACER: "SALES_LIST_RENDER_KIND_SPACER",

  SALES_SET_RESORT_LOAD_REQUEST: "SALES_SET_RESORT_LOAD_REQUEST",
  HIDE_REFUND: "HIDE_REFUND",
  DISPLAY_REFUND_BLOCK: "DISPLAY_REFUND_BLOCK",

  STATISTICS_SET_RESORT: "STATISTICS_SET_RESORT",
  STATISTICS_REDUCED_PARAMETERS: "STATISTICS_REDUCED_PARAMETERS",
  STATISTICS_EXTENDED_PARAMETERS: "STATISTICS_EXTENDED_PARAMETERS",
  STATISTICS_INIT_FILTERS: "STATISTICS_INIT_FILTERS"
};

/*
DISPLAY_REFUND: 'DISPLAY_REFUND',
*/



// WEBPACK FOOTER //
// ./src/auth/constants.js